// extracted by mini-css-extract-plugin
export default {"HomeThird":"HomeThird_HomeThird__x5XNr","box":"HomeThird_box__zUjTJ","vid":"HomeThird_vid__ITsYo","info":"HomeThird_info__HZWnU"};